import { AccessControlProvider } from "@refinedev/core";

import { getUser, verifyUser } from './user';

export const accessControlProvider = {

  can: async ({ resource, action, params }) => {

    // console.log(resource); // products, orders, etc.
    // console.log(action); // list, edit, delete, etc.
    // console.log(params); // { id: 1 }, { id: 2 }, etc.

    // console.log('Verifying user...');

    let _user = localStorage.getItem('userIdentity'), user;

    if(_user){

      user = JSON.parse(_user);
      console.log(`Already stored user: `, user);

    }



    if(!user){

      console.log(`User not found on local storage...`);

      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const uid = urlParams.get('uid');

      console.log(`User uid: ${ uid }`);

      if(uid){

          let uidValidation = await verifyUser(uid).catch(e => {

            console.log(`User couldn't be verified. Sending to login...`);
            window.location.href="https://sundekapp.com";

          });

          console.log(`Uid validation result: `, uidValidation);

          return {
            can: true
          }

      } else {

        // alert(`User not logged In. You'll be redirected to main menu login.`);

        window.location.href="https://sundekapp.com";

        return {
          can: false,
          reason: "Unauthorized",
        };

      }

      
    }


    // if(params.resource?.meta?.parent === 'Management'){

    //   if(user.role === "administrator"){

    //     return { can: true }

    //   } else {
    //     window.location.href="https://sundekapp.com";
    //     return {
    //       can: false,
    //       reason: "Unauthorized",
    //     };
    //   }

    // }

    return { can: true }
    
  },

};


